import PortalLayout from "@/components/portal/PortalLayout";
import { ChatbotList } from "@/components/portal/ChatbotList";

const PortalChatbots = () => {
  return (
    <PortalLayout>
      <div className="flex-1 space-y-4 p-4 md:p-8 pt-6">
        <ChatbotList />
      </div>
    </PortalLayout>
  );
};

export default PortalChatbots;
